/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import fondo from '../Recursos/fondo_footer.svg'
import {REDES} from "../Constantes";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";

const Footer = () => {
    const {masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `url(${fondo})`,
                backgroundSize: 'cover',
                borderTopRightRadius: 30,
                borderTopLeftRadius: 30,

            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{color: '#fff'}}
                                spacing={2}
                            >

                                {items.map((item, index) => (
                                    <Grid container size={{xs: 6, sm: 4, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontSize: 16, fontWeight: 600}}>{item}</Typography>
                                    </Grid>
                                ))}


                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 4}}>
                                    <Typography sx={{color: '#fff'}}>© EcoFarmaline S.A.S.</Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'center', mt: !masSM ? 4 : 0}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 8, sm: 4, md: 8}} sx={{justifyContent: 'flex-start'}}>
                                    <Grid
                                        container
                                        justifyContent={'space-between'}
                                        alignItems={'flex-start'}
                                        size={{xs: 12, sm: 12, md: 12}}>

                                        {REDES.map((item, index) => (
                                            <IconButton>
                                                <img src={item.img} width={32} height={'auto'}/>
                                            </IconButton>
                                        ))}

                                    </Grid>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                                    <Typography sx={{color: '#fff', fontWeight: 600, fontSize: 20}}>¡Síguenos!</Typography>
                                </Grid>

                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>



            </Grid>
        </Grid>
    )

}
export default Footer

const items = ['Home', 'Marketplace', 'Empresas', 'Contacto', 'Dropshipping', 'Tienda', 'Educación', 'Legal']